((app, ng) => {

    app.component("acmAccountInfoButton",
        {
            template: `
                <md-button class="md-icon-button btn-acm" ng-click="$ctrl.openAcmAccountInfo($event)">
                    <md-icon md-svg-src="/Images/Logos/alphastar-logo-icon.svg" aria-label="ACM Data"></md-icon>
                    <md-tooltip md-delay="500">Alphastar CM</md-tooltip>
                </md-button>
            `,
            controller: acmAccountInfoButtonController,
            bindings: {
                acmAccountGuid: "<"
            }
        });

    function acmAccountInfoButtonController(modalService) {
        const $ctrl = this;

        const openAcmAccountInfo = ($event) => {
            modalService.openAcmAccountInfo($ctrl.acmAccountGuid, $event);
        }

        ng.extend($ctrl,
            {
                openAcmAccountInfo
            });
    }

})(window.app, window.angular);